module.exports = __webpack_public_path__ + "media/images/smart_phone/logo_mini-fd7aa56251377a929ef63e70b92c8380.png";